// extracted by mini-css-extract-plugin
export var addToCartButton = "_tt-b";
export var arrowButtonContainer = "_tt-9";
export var arrowButtonIcon = "_tt-a";
export var carouselArrowButton = "_tt-6";
export var carouselElementContainer = "_tt-1";
export var left = "_tt-7";
export var productDisplayCarouselContainer = "_tt-0";
export var productTileContainer = "_tt-2";
export var productTileImage = "_tt-4";
export var productTileImageContainer = "_tt-3";
export var productTileTitle = "_tt-5";
export var right = "_tt-8";
export var sliderOverflow = "_tt-c";